import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { ErrorService } from '@cosmos/angular/utils';
import { environment } from '../../../../../../environments/environment';
import { catchError, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TokensService {

  constructor(
    private http: HttpClient,
    private errorService: ErrorService,
  ) { }

  findByDeviceId(deviceId: string): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(`${environment.API_URL}/token/device/${deviceId}`, { observe: 'response' })
      .pipe(
        map(response => response),
        catchError((error) =>{this.errorService.handleError(error); throw error;})
      );
  }

  createDeviceToken(email: string, userId: string, deviceId: string): Observable<HttpResponse<string>> {
    return this.http
      .post<string>(`${environment.API_URL}/token/device`, { email, userId, deviceId }, { observe: 'response' })
      .pipe(
        map(response => response),
        catchError((error) =>{this.errorService.handleError(error); throw error;})
      );
  }

  delete(token: string): Observable<HttpResponse<any>> {
    return this.http
      .delete<any>(`${environment.API_URL}/token/${token}`, { observe: 'response' })
      .pipe(
        map(response => response),
        catchError((error) =>{this.errorService.handleError(error); throw error;})
      );
  }
}
